import * as React from "react";
import { Provider } from "@fluentui/react-northstar/dist/es/components/Provider/Provider";
import { useEffect } from "react";
import { useTeams } from "msteams-react-base-component";
import * as microsoftTeams from "@microsoft/teams-js";
import { LocalCacheHelper } from "../../helpers/LocalCacheHelper";
import CpbxLogin from "../../components/CpbxLogin/CpbxLogin";
import CpbxAppSettings from "../../components/AppSettings/CpbxAppSettings";
import { ICpbxLoginProps } from "../../components/CpbxLogin/ICpbxLoginProps";
import { CpbxThemeSelector } from "../../components/CpbxThemeSelector/cpbxThemeSelector";
import Verhinderung from "../../components/Verhinderung/Verhinderung";
/**
 * Implementation of the TabDevTest content page (for SBK, FADE)
 */
export const TabAppSettings = () => {

    /*  ############################################################
        here is some stuff which you may use or not...
       - to get information if user is in teams-browser or normal browser (not within teams-app)
       - and other stuff (o365-login-info, theme to use, etc.)
    */
    const [{ inTeams, theme, context }] = useTeams();

    // magic initialization-stuff
    useEffect(() => {
        if (inTeams === true) {
            microsoftTeams.appInitialization.notifySuccess();
        }
        if (inTeams === false) {
            const outContext = { theme: "default" };
            CpbxThemeSelector(outContext);
        }
    }, [inTeams]);

    // check if login has been done already
    const isCpbxLoggedIn: boolean = LocalCacheHelper.DoesLocalCacheKeysForCbpxLoginExists();

    // check if we do have an o365-teams-context (meaning we are in teams-app and we are possibly logged in)
    useEffect(() => {
        microsoftTeams.registerOnThemeChangeHandler(function(theme) {
            CpbxThemeSelector(theme);
            console.log(theme);
        });
        if (context) {
            CpbxThemeSelector(context);
        }
    }, [context]);

    /*  ############################################################
        This is the stuff for html-output.
    */

    // output all in fully declartive way (not dynamically)
    if (isCpbxLoggedIn) {
        /*
        const cpbxUsername: string = LocalCacheHelper.GetLocalStorageItemCbpxUserNameAsString();
        const cpbxImpId: string = LocalCacheHelper.GetLocalStorageItemCbpxUserImpIdFromProfileMe();
        const contextProps : ICpbxLoginInfoProps = {
            M365Upn: msTeamsUpn,
            CpbxUser: cpbxUsername,
            CpbxImpId: cpbxImpId
        };
        // check if ms-teams context is available
        if (context) {
            // context is available so do not show headline
            return (
                <Provider theme={theme} className="CpbxProviderContainer">
                    <CpbxLoginInfo {...contextProps} />
                    <CpbxAppSettings/>
                </Provider>
            );
        } else {
            // context is NOT available so do show some additional information for web-view (without ms-teams)

            const items: IBreadcrumbItem[] = [
                { text: "Home", key: "home", href: "/" },
                { text: "Directory", key: "directory", isCurrentItem: true }
            ];

            return (
                <Provider theme={theme} className="CpbxProviderContainer">
                    <Breadcrumb items={items} />
                    <CpbxLoginInfo {...contextProps} />
                    <CpbxAppSettings />
                </Provider>
            );
        }
        */
        return (
            <Provider theme={theme} className="cpbxProviderContainer">
                <CpbxAppSettings />
            </Provider>
        );

    } else {
        const localDevTestUserId = "11111111-1111-1111-1111-111111111111";
        const cpbxLoginProps: ICpbxLoginProps = {
            M365UserObjectId: (context === undefined || context.userObjectId === undefined) ? localDevTestUserId : context.userObjectId
        };
        return (

            <Provider theme={theme} className="cpbxProviderContainer">
                <CpbxLogin {...cpbxLoginProps} />
                <Verhinderung/>
            </Provider >

        );
    }

};
